/*
@license
  Newsletter runtime extracted from Impulse by Archetype Themes.
*/
(function() {
  'use strict';

  if (window.__abrsmNewsletterPopupRuntimeLoaded) {
    return;
  }
  window.__abrsmNewsletterPopupRuntimeLoaded = true;

/*============================================================================
    NewsletterReminder
  ==============================================================================*/
  
  class NewsletterReminder extends HTMLElement {
    constructor() {
      super();
      this.closeBtn = this.querySelector('[data-close-button]');
      this.popupTrigger = this.querySelector('[data-message]');
  
      this.id = this.dataset.sectionId;
      this.newsletterId = `NewsletterPopup-${ this.id }`;
      this.cookie = Cookies.get(`newsletter-${this.id}`);
      this.cookieName = `newsletter-${this.id}`;
      this.secondsBeforeShow = this.dataset.delaySeconds;
      this.expiry = parseInt(this.dataset.delayDays);
      this.modal = new theme.Modals(`NewsletterPopup-${this.newsletterId}`, 'newsletter-popup-modal');
  
      this.init();
    }
  
    init() {
      document.addEventListener('shopify:block:select', (evt) => {
        if (evt.detail.sectionId === this.id) {
          this.show(0, true)
        }
      });
  
      document.addEventListener('shopify:block:deselect', (evt) => {
        if (evt.detail.sectionId === this.id) {
          this.hide();
        }
      });
  
      document.addEventListener(`modalOpen.${this.newsletterId}`, () => this.hide());
      document.addEventListener(`modalClose.${this.newsletterId}`, () => this.show());
      document.addEventListener(`newsletter:openReminder`, () => this.show(0));
  
      this.closeBtn.addEventListener('click', () => {
        this.hide();
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: this.expiry });
      });
  
      this.popupTrigger.addEventListener('click', () => {
        const reminderOpen = new CustomEvent('reminder:openNewsletter', { bubbles: true });
        this.dispatchEvent(reminderOpen);
  
        this.hide();
      });
    }
  
    show(time = this.secondsBeforeShow, forceOpen = false) {
      const reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');
  
      if (!reminderAppeared) {
        setTimeout(() => {
          this.dataset.enabled = 'true';
          sessionStorage.setItem('reminderAppeared', true);
        }, time * 1000);
      }
    }
  
    hide() {
      this.dataset.enabled = 'false';
    }
  }
  
  customElements.define('newsletter-reminder', NewsletterReminder);

theme.NewsletterPopup = (function () {
    var autoSuppressPaths = [
      '/products',
      '/search',
      '/cart',
      '/pages/faq',
      '/pages/contact',
      '/pages/returns',
      '/pages/returns-policy',
      '/pages/refund-policy',
      '/pages/shipping-policy',
      '/pages/privacy-policy',
      '/pages/cookie-policy',
      '/pages/terms-of-service',
      '/pages/policy-centre'
    ];

    var reminderOnlyPaths = [
      '/collections',
      '/pages/syllabus-finder'
    ];

    function normalizedPath() {
      return window.location.pathname.replace(/\/+$/, '').toLowerCase() || '/';
    }

    function isAutoSuppressedSurface() {
      var path = normalizedPath();

      return autoSuppressPaths.some(function (blockedPath) {
        return path === blockedPath || path.indexOf(blockedPath + '/') === 0;
      });
    }

    function isReminderOnlySurface() {
      var path = normalizedPath();

      return reminderOnlyPaths.some(function (reminderPath) {
        return path === reminderPath || path.indexOf(reminderPath + '/') === 0;
      });
    }

    function isVisibleUiLayer(element) {
      if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') {
        return false;
      }

      var style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
        return false;
      }

      var rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }

    function hasVisibleUiLayer(selector) {
      return Array.prototype.some.call(document.querySelectorAll(selector), isVisibleUiLayer);
    }

    function hasActiveShoppingFocus() {
      var target = document.activeElement;
      if (!target || !target.closest) {
        return false;
      }

      return Boolean(target.closest([
        'input[type="search"]',
        '.hdr-search',
        '.abrsm-msearch',
        '.collection-filter',
        '.filter-form',
        '.facets',
        '.abrsm-facet',
        '.abrsm-drawer',
        '.abrsm-filter-toggle',
        '#FilterDrawer',
        '#CartDrawer',
        '.cart-drawer',
        '.main-cart-page',
        'form[action*="/cart/add"]',
        '[data-add-to-cart]',
        '.add-to-cart',
        '.js-drawer-open-cart'
      ].join(',')));
    }

    function hasActiveStorefrontLayer() {
      if (
        document.body.classList.contains('predictive-overflow-hidden') ||
        document.body.classList.contains('js-drawer-open') ||
        document.documentElement.classList.contains('js-drawer-open') ||
        document.body.classList.contains('modal-open') ||
        document.documentElement.classList.contains('modal-open') ||
        document.documentElement.classList.contains('cart-open')
      ) {
        return true;
      }

      var activeLayerSelectors = [
        'predictive-search.is-active',
        '.hdr-suggest.is-active',
        '.abrsm-msearch[aria-hidden="false"]',
        '.drawer.drawer--is-open',
        '.drawer.is-active',
        '.abrsm-drawer[role="dialog"]',
        '#FilterDrawer[aria-hidden="false"]',
        '#CartDrawer[aria-hidden="false"]',
        '.modal.modal--is-active',
        '.abrsm-pdp-format-modal.is-active',
        '[aria-modal="true"]:not([aria-hidden="true"])'
      ];

      return activeLayerSelectors.some(function (selector) {
        return hasVisibleUiLayer(selector);
      });
    }

    function NewsletterPopup(container) {
      this.container = container;
      var sectionId = this.container.getAttribute('data-section-id');
  
      this.cookieName = 'newsletter-' + sectionId;
      this.cookie = Cookies.get(this.cookieName);
  
      if (!container) {
        return;
      }
  
      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }
  
      // Prevent popup on password page
      if (window.location.pathname === '/password') {
        return;
      }
  
      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds,
        daysBeforeReappear: container.dataset.delayDays,
        hasReminder: container.dataset.hasReminder,
        testMode: container.dataset.testMode
      };

      this.popupDelayTimer = null;
      this.preferReminder = false;
  
      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
  
      // Set cookie if optional button is clicked
      var btn = container.querySelector('.popup-cta a');
      if (btn) {
        btn.addEventListener('click', function () {
          this.closePopup(true);
        }.bind(this));
      }
  
      // Open modal if errors or success message exist
      if (container.querySelector('.errors') || container.querySelector('.note--success')) {
        this.modal.open();
      }
  
      // Set cookie as opened if success message
      if (container.querySelector('.note--success')) {
        this.closePopup(true);
        return;
      }
  
      document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));
  
      if (!this.cookie) {
        this.initPopupDelay();
      }
  
      // Open modal if triggered by newsletter reminder
      document.addEventListener('reminder:openNewsletter', () => {
        this.modal.open();
      });
    }
  
    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      initPopupDelay: function () {
        if (this.data.testMode === 'true') {
          return;
        }

        if (isAutoSuppressedSurface()) {
          return;
        }

        this.queuePopupOpen(this.data.secondsBeforeShow);
      },

      queuePopupOpen: function (secondsBeforeShow) {
        if (this.popupDelayTimer) {
          window.clearTimeout(this.popupDelayTimer);
        }

        this.popupDelayTimer = window.setTimeout(function () {
          this.popupDelayTimer = null;
          this.openPopupWhenAvailable();
        }.bind(this), secondsBeforeShow * 1000);
      },

      shouldDeferAutoOpen: function () {
        return hasActiveStorefrontLayer() || hasActiveShoppingFocus();
      },

      showReminder: function () {
        if (this.data.hasReminder !== 'true') {
          return false;
        }

        var openReminder = new CustomEvent('newsletter:openReminder', { bubbles: true });
        this.container.dispatchEvent(openReminder);
        sessionStorage.setItem('newsletterAppeared', true);
        return true;
      },

      openPopupWhenAvailable: function () {
        if (this.cookie || this.data.testMode === 'true') {
          return;
        }

        if (isAutoSuppressedSurface()) {
          return;
        }

        if (this.shouldDeferAutoOpen()) {
          this.preferReminder = true;
          this.queuePopupOpen(5);
          return;
        }

        setTimeout(function () {
          if (isAutoSuppressedSurface()) {
            return;
          }

          if (this.shouldDeferAutoOpen()) {
            this.preferReminder = true;
            this.queuePopupOpen(5);
            return;
          }

          if ((isReminderOnlySurface() || this.preferReminder) && this.showReminder()) {
            return;
          }

          const newsletterAppeared = (sessionStorage.getItem('newsletterAppeared') === 'true');
          if (newsletterAppeared) {
            const openReminder = new CustomEvent('newsletter:openReminder', { bubbles: true });
            this.container.dispatchEvent(openReminder);
          } else {
            this.modal.open();
            sessionStorage.setItem('newsletterAppeared', true);
          }
  
        }.bind(this), 900);
      },
  
      closePopup: function (success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }
  
        var expiry = success ? 200 : this.data.daysBeforeReappear;
        var hasReminder = (this.data.hasReminder === 'true');
        var reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');
  
        if (hasReminder && reminderAppeared) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        } else if(!hasReminder) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        }
      },
  
      onLoad: function () {
        this.modal.open();
      },
  
      onSelect: function () {
        this.modal.open();
      },
  
      onDeselect: function () {
        this.modal.close();
      },
  
      onBlockSelect: function () {
        this.modal.close();
      },
  
      onBlockDeselect: function () {
        this.modal.open();
      },
  
      onUnload: function() {
        if (this.popupDelayTimer) {
          window.clearTimeout(this.popupDelayTimer);
        }
        this.modal.close();
      }
    });
  
    return NewsletterPopup;
  })();

  function registerNewsletterPopup() {
    if (!window.theme || !theme.sections || !theme.NewsletterPopup) {
      return;
    }

    if (theme.sections.constructors['newsletter-popup']) {
      return;
    }

    theme.sections.register('newsletter-popup', theme.NewsletterPopup);
  }

  if (window.theme && theme.sections) {
    registerNewsletterPopup();
  } else {
    document.addEventListener('page:loaded', registerNewsletterPopup, { once: true });
  }
})();
